/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { BrowserCacheLocation, RedirectRequest } from '@azure/msal-browser';

// Prod builds use sessionStorage (tokens cleared on tab close — safer SPA posture).
// Dev/e2e use localStorage so Playwright's storageState (which cannot persist
// sessionStorage) can seed and reuse the MSAL cache regardless of who launched the
// dev server. The env var override is kept for explicit control.
const cacheLocation: BrowserCacheLocation =
  import.meta.env.DEV || import.meta.env.VITE_MSAL_CACHE_LOCATION === 'localStorage'
    ? 'localStorage'
    : 'sessionStorage';

export const msalConfig = {
  auth: {
    clientId: '3363f9d4-aca6-4091-b3e3-a0154cf484e6',
    authority: 'https://login.microsoftonline.com/f10c781c-d289-4af9-bc2c-a08efe919638',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation, // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: RedirectRequest = {
  scopes: ['User.Read'],
};
